export default "__VITE_ASSET__CB1sul7A__"